import qs from "qs";

export const serializeToQueryString = (obj: any): string => {
  return qs.stringify(obj, {
    skipNulls: true,
    arrayFormat: "comma",
    allowDots: true
  });
};

export const appendQueryString = (obj: any) => {
  const queryString = serializeToQueryString(obj);
  if (queryString.length === 0) {
    window.history.pushState({}, "", window.location.pathname);
    return;
  }
  const newUrl = `${window.location.pathname}?${queryString}`;
  window.history.pushState({}, "", newUrl);
};